import { makeRequest, CommonRequestOptions } from '../../makeRequest';
import { ColumnSettings } from './@types';

export type GetUserManageTableColumnsResult = ColumnSettings[];

export async function getUserManageTableColumns({
   ...common
}: CommonRequestOptions): Promise<GetUserManageTableColumnsResult> {
   return makeRequest('get', `users/manage_table`, {
      ...common,
   });
}
